<template>
    <div class="loginbg">
        <div class="container">
            <div class="row">
                <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
                    <div class="loginform">
                        <div class="loginlogo">
                            <img src="/static/images/login-logo.png" alt="Velocity Vehicle Group">
                        </div>
                        <form>
                            <template v-if="ssoLogin == 'true'">
                                <div class="form-group" v-if="!error">Signing you in through SSO...</div>
                                <div class="c-error">{{error}}</div>
                                <button v-on:click.prevent="redirectToSSO(true)" type="submit" class="btn btn-primary">Login with SSO</button>
                            </template>
                            <template v-else>
                            <div class="form-group">
                                <label for="exampleInputEmail1">Email address</label>
                                <input v-model="username" type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email address">
                                <!-- <font class="text-danger" v-html="usernameError"></font> -->
                                <div class="c-error">{{usernameError}}</div>
                            </div>
                            <div class="form-group">
                                <label for="exampleInputPassword1">Password</label>
                                <input v-model="password" type="password" class="form-control" id="exampleInputPassword1" placeholder="Enter password">
                                <!-- <font class="text-danger" v-html="passwordError"></font> -->
                                <div class="c-error">{{passwordError}}</div>
                            </div>


                            <div class="c-error">{{error}}</div>
                            <!-- <div class="form-check">
                                <label class="checkbox-inline checkbox-bootstrap checkbox-lg">
                                    <input type="checkbox">
                                    <span class="checkbox-placeholder"></span>
                                    Remember me
                                </label>
                            </div> -->

                            <button v-on:click.prevent="login()" type="submit" class="btn btn-primary">Login</button>
                            <a :href="forgot_pass_url" target="_blank">Forgot password?</a>
                            </template>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import {HTTP} from '../http-common';
    import EventBus from './event-bus';
    import moment from 'moment';

    Vue.use(VueGoodTable);

    var self;
    export default {
        name: 'Login',
        data() {
            return {
                username : '',
                password : '',
                error: '',
                // Frontend Errors
                usernameError : '',
                passwordError : '',
                forgot_pass_url: '',
                browserTimeZone : "",
                ssoLogin: 'false',
            }

        },
        beforeMount: function () {
            self = this;
            self.browserTimeZone = moment.tz.guess();
            self.ssoLogin = process.env.SSO_LOGIN;

            if (self.ssoLogin == 'true') {
                // SSO redirects back to /login?token=...&username=...
                var token = self.$route.query.token;
                if (token) {
                    // keep the token out of the address bar and browser history
                    self.$router.replace('/login');
                    self.autoLoginUser(token);
                } else {
                    self.redirectToSSO(false);
                }
            }
        },
        mounted: function () {
            self = this;

            // $("#exampleInputEmail1").on('keyup', function () {
            //     self.usernameError = '';
            // });
            // $("#exampleInputPassword1").on('keyup', function () {
            //     self.passwordError = '';
            // });
            // $("#exampleInputPassword1").on('change', function () {
            //     self.passwordError = '';
            // });
            $("input").keypress(function(e) {
              if (e.keyCode === 13) {
                if (e.target.id == "exampleInputEmail1" || e.target.id == "exampleInputPassword1") {
                  e.preventDefault();
                //   console.log("Enter Triggered");
                  self.login();
                }
              }
            });

            self.forgot_pass_url = process.env.HR_URL + "?identify=" + window.location.href;
        },
        methods: {
            validation: function () {
                var checked = true;

                if (!self.username) {
                    self.usernameError = "Email address Required.";
                    if (checked) {
                        checked = false;
                    }
                } else if (!self.validEmail(self.username)) {
                    self.usernameError = 'Please Enter Valid Email address';
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.password) {
                    self.passwordError = "Password Required.";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            login: function () {
                self.usernameError = '';
                self.passwordError = '';
                self.error = '';
                // self.validation();
                if (self.validation()) {
                    var data = {
                        username : self.username,
                        password : self.password,
                    }
                    HTTP.post('/login',data)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.completeLogin(response.data.content);
                            }
                        })
                        .catch(function (err) {
                            console.log(err);
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        })
                }
            },
            completeLogin: function (content) {
                window.localStorage.setItem('browserTimeZone', self.browserTimeZone);
                window.localStorage.setItem("api_token", content.api_token);
                // SSO token, used to change passwords on SSO (Edit User > Change Password)
                if (content.access_token) {
                    window.localStorage.setItem("access_token", content.access_token);
                }
                window.localStorage.setItem("user_obj", JSON.stringify(content.user_obj));

                let userCurrentLocation = JSON.parse(localStorage.getItem("user_obj"))['user_current_location'];
                let current_location_view = "";

                if (userCurrentLocation === "primary") {
                    current_location_view = "front_end";
                } else if (userCurrentLocation === "secondary") {
                    current_location_view = "will_call";
                }
                window.localStorage.setItem("current_location_view", current_location_view);
                //self.$router.push("/closeticket");
                self.$router.push("/");

                var userObj = JSON.parse(localStorage.getItem("user_obj"));
                if (userObj != null) {
                    EventBus.$emit('login-user-info', userObj.username, userObj.first_name, userObj.last_name, userObj.location_name, userObj.will_call_location_name);
                }
            },
            redirectToSSO: function (userClicked) {
                // SSO sends the user back without a token when the slug isn't registered or access is
                // missing; don't bounce between the two again right away, show the error instead
                var lastRedirect = parseInt(window.sessionStorage.getItem('sso_redirect_at') || '0');
                if (!userClicked && Date.now() - lastRedirect < 60000) {
                    self.error = "Could not sign in through SSO. Please check that you have access to this application, or contact admin.";
                    return;
                }
                window.sessionStorage.setItem('sso_redirect_at', Date.now());
                window.location.href = process.env.SSO_ROOT_URL + '/login?redirect=' + process.env.FRONT_ROOT_URL + '/login' + '&slug=' + process.env.PROJECT_SLUG;
            },
            autoLoginUser: function (token) {
                self.error = '';
                HTTP.post('/autologinuser', {access_token: token})
                    .then(function (response) {
                        if (response.data.code == '200') {
                            window.sessionStorage.removeItem('sso_redirect_at');
                            self.completeLogin(response.data.content);
                        }
                    })
                    .catch(function (err) {
                        if (!err.response || err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            self.error = err.response.data.message;
                        }
                    })
            },

        }
    }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Login.vue